module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-circle-dotted-2077d00b.svg";